import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {state} from '@bitstillery/mithril'
import {Button, FieldText} from '@bitstillery/common/components'
import {and, must_match, password, required, validation} from '@bitstillery/common/lib/validation'
import {$m, $t, api, notifier} from '@bitstillery/common/app'

import {property_of, route_param_text} from '@bitstillery/common/lib/utils'

export class AuthResetPassword extends MithrilComponent {
    data = (() => {
        const form = {
            password: '',
            password_repeat: '',
        }

        return state({form}, 'auth-reset-password-data')
    })()

    $v = {
        password: validation(this.data.form.$password, and([required(), password()])),
        password_repeat: validation(
            this.data.form.$password_repeat,
            and([required(), password(), must_match(this.data.form.$password)]),
        ),
    }

    request_id = route_param_text(m.route.param('request_id'))
    is_new_account = m.route.param('is_new_account')

    async submit() {
        if (process.env.MSI_PACKAGE === 'portal') {
            const data = {
                new_password: this.data.form.password,
                request_id: this.request_id ?? '',
            }
            const {error_result, success} = await api.post('portal/user/reset-password', data, true)
            if (!success) {
                notifier.notify($t('password_reset.failed', {reason: error_result?.detail}), 'danger', 5000)
                return
            }
        } else {
            const data = {
                password: this.data.form.password,
                request_id: this.request_id,
            }

            const {result, status_code} = await api.post('auth.reset_password', data)
            if (status_code > 299) {
                // A v1 factserver error body carries its reason in `message`.
                const reason = property_of(result, 'message')
                notifier.notify(
                    $t('password_reset.failed', {reason: typeof reason === 'string' ? reason : undefined}),
                    'danger',
                    5000,
                )
                return
            }
        }

        notifier.notify($t('password_reset.confirmed'), 'info')
        $m.identity.logout()
    }

    view() {
        const new_or_reset = this.is_new_account ? 'new-account' : 'reset'
        return (
            <div className='c-auth-reset-password landing'>
                <div className='form stepper-form'>
                    <div className='step'>
                        <h3>{$t(`password_reset.title.${new_or_reset}`)}</h3>
                        <p className='step-info'>{$t(`password_reset.description.${new_or_reset}`)}</p>

                        <FieldText
                            label={$t('password_reset.new_password')}
                            model={this.data.form.$password}
                            help={$t('password_reset.new_password_help')}
                            type='password'
                            validation={this.$v.password}
                        />

                        <FieldText
                            label={$t('password_reset.new_password_repeat')}
                            model={this.data.form.$password_repeat}
                            help={$t('password_reset.new_password_repeat_help')}
                            type='password'
                            validation={this.$v.password_repeat}
                        />
                    </div>

                    <Button
                        disabled={Object.values(this.$v).filter((i) => i._invalid).length > 0}
                        onclick={this.submit.bind(this)}
                        text={$t('password_reset.reset_button')}
                        type='success'
                    />
                </div>
            </div>
        )
    }
}
